module.exports = __webpack_public_path__ + "ccad6f148a1146e1af3eb31c223c73be.svg";